import { createSlice } from '@reduxjs/toolkit';

export const Door_OFFLINESlice = createSlice({
    name:'door_OFFLINESlice',
    initialState:{
        loading: false,
        main_loading: true,
        data: {

        },
        main_data:[],
        error: false,
    },
    reducers:{
        DOOR_OFFLINE_FETCH_START:(state)=>{
            state.loading=true
        },
        DOOR_OFFLINE_FETCH_SUCCESS:(state,action)=>{
            state.loading=false
            state.data=action.payload
            state.main_loading=false
            state.main_data=action.payload.sites
        },

        DOOR_OFFLINE_FETCH_MORE_SUCCESS:(state,action)=>{
           state.loading=false
            state.data=action.payload
            state.main_data=[...state.main_data,...action.payload.sites]
        },

        EDIT_DOOR_OFFLINE_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            const newArray = state.main_data.filter(todo => todo.id !==action.payload.id)
             state.main_data = [...newArray,action.payload]
        },
        DOOR_OFFLINE_FETCH_ERROR:(state)=>{
            state.error=true
        }
    }
});

export const {DOOR_OFFLINE_FETCH_MORE_SUCCESS, DOOR_OFFLINE_FETCH_START,DOOR_OFFLINE_FETCH_SUCCESS,DOOR_OFFLINE_FETCH_ERROR,EDIT_DOOR_OFFLINE_FETCH_SUCCESS }=Door_OFFLINESlice.actions;
export default Door_OFFLINESlice.reducer;